export var ToastStyle;
(function (ToastStyle) {
    ToastStyle["MATERIAL"] = "material-theme";
    ToastStyle["DARK"] = "dark-theme";
    ToastStyle["SIMPLE"] = "simple-theme";
})(ToastStyle || (ToastStyle = {}));
export var ToastBackdrop;
(function (ToastBackdrop) {
    ToastBackdrop[ToastBackdrop["NONE"] = -1] = "NONE";
    ToastBackdrop[ToastBackdrop["WEAK"] = 0.2] = "WEAK";
    ToastBackdrop[ToastBackdrop["NORMAL"] = 0.4] = "NORMAL";
    ToastBackdrop[ToastBackdrop["STRONG"] = 0.7] = "STRONG";
    ToastBackdrop[ToastBackdrop["FULL"] = 1] = "FULL";
})(ToastBackdrop || (ToastBackdrop = {}));
//# sourceMappingURL=toast.enum.js.map